<template>
  <div>
    <v-card color="grey lighten-4" flat tile>
      <v-toolbar dense>
        <v-toolbar-title>Daftar Barang</v-toolbar-title>

        <v-spacer></v-spacer>

        <div>
          <v-text-field
            dense
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="hidden-sm-and-down"
          />
        </div>
      </v-toolbar>
    </v-card>
    <div class="mt-5">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Gambar</th>
              <th class="text-left">Nama Barang</th>
              <th class="text-left">Berat</th>
              <th class="text-left">Harga</th>
              <th class="text-left">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.idbarang">
              <td>
                <div>
                  <v-avatar tile>
                    <img :src="getImageUrl(item.gambar)" alt="John" />
                  </v-avatar>
                </div>
              </td>
              <td>
                <b>{{ item.nama_item }}</b>
              </td>
              <td>{{ item.berat }} Kg</td>
              <td>{{ item.harga | currency }}</td>
              <td>
                <v-btn @click="deleteBarang(item.idbarang)" icon color="#D32F2F">
                  <v-icon>fas fa-trash</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      items: [],
      overlay: false,
      userid: localStorage.getItem("user_id"),
      headers: [
        {
          text: "Gambar",
          align: "start",
          sortable: false,
          value: "gambar"
        },
        { text: "Nama Barang", value: "nama_item" },
        { text: "Berat (kg)", value: "berat" },
        { text: "Harga", value: "harga" }
      ]
    };
  },
  mounted() {
    this.getMyItems();
  },
  methods: {
    getMyItems() {
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/viewbarangtoko/" + this.userid
      )
        .then(response => response.json())
        .then(data => {
          this.items = data.barang;
        });
    },
    deleteBarang(e) {
      console.log(e);
      Swal.fire({
        title: "Barang akan dihapus",
        text: "Apakah anda yakin ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya, Lanjutkan!"
      }).then(result => {
        this.overlay = true;
        if (result.value) {
          fetch("http://meridinet.saebo.id:2082/Login/api/tabel/delbarang", {
            method: "POST",
            body: JSON.stringify({
              id: e
            }),
            headers: {
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*"
            }
          })
            .then(response => response.json())
            .then(data => {
              console.log(data);
              if (data == 200) {
                Swal.fire("Sukses", "Barang di hapus", "success");
                this.getMyItems();
                this.overlay = false;
              } else if (data == 404) {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Barang Gagal Di Hapus"
                });
              }
            });
        }
      });
    },
    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    }
  }
};
</script>
